import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

// Lazy load route components for better initial bundle size
const Why = lazy(() => import("./pages/Why"));
const Success = lazy(() => import("./pages/Success"));
const Program = lazy(() => import("./pages/Program"));
const TalentManagement = lazy(() => import("./pages/TalentManagement"));
const Apply = lazy(() => import("./pages/Apply"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contact = lazy(() => import("./pages/Contact"));
const Auth = lazy(() => import("./pages/Auth"));
const Admin = lazy(() => import("./pages/Admin"));
const CreatorPortalLanding = lazy(() => import("./pages/CreatorPortalLanding"));
const CreatorPortalDashboard = lazy(() => import("./pages/CreatorPortalDashboard"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-pulse text-lg">Loading...</div></div>}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/why" element={<Why />} />
            <Route path="/success" element={<Success />} />
            <Route path="/program" element={<Program />} />
            <Route path="/talent-management" element={<TalentManagement />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/creator-portal" element={<CreatorPortalLanding />} />
            <Route path="/creator-portal/dashboard" element={<CreatorPortalDashboard />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
